// @ts-nocheck
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
// sentry
import * as Sentry from '@sentry/react';
// Utils
import configureStore, { ReactReduxContext } from './config/configureStore';
import 'fontsource-roboto';
// components
import App from './App';
// styles
import './commons/assets/styles.scss';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://18d4e8dc1b7c426b9a81cc398609534f@o96110.ingest.sentry.io/5369982', // comment for dev
  });
}

const store = configureStore();
const persistor = persistStore(store);

const renderApp = () => render(
  <Provider store={store} context={ReactReduxContext}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App context={ReactReduxContext} />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.querySelector('#root'),
);

renderApp();

if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    // Support hot reloading of components
    // and display an overlay for runtime errors
    module.hot.accept('./App', () => {
      renderApp();
    });
  }
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js');
  });
} else {
  console.log('serviceWorker not available');
}

export default store;